import { __rest } from "tslib";
import { createElement, useEffect } from 'rax';
import { isFunction } from '../utils';
const RichTextImage = (props) => {
    const { item, className, src, style, id, onLoad, onPlay } = props, otherProps = __rest(props, ["item", "className", "src", "style", "id", "onLoad", "onPlay"]);
    const handlePlay = () => {
        if (isFunction(onPlay)) {
            onPlay(id);
        }
    };
    useEffect(() => {
        if (isFunction(onLoad)) {
            onLoad(id);
        }
    }, []);
    return <video {...otherProps} id={id} src={src} style={style} className={className} onPlay={handlePlay}/>;
};
export default RichTextImage;
